import { getFetchedDataPayload } from '@vista-digital/utilities';
import { reduceToArray } from '../../../../utils/reduce-to-array';
import { browsingDomainStore } from '../../store';
import { getFilmById } from './get-film-by-id';
export const getFilmsForSite = (siteId) => {
    const filmIds = getFetchedDataPayload(browsingDomainStore.data.filmIdsBySiteId[siteId]);
    return filmIds ? reduceToArray(filmIds, getFilmById) : undefined;
};
//# sourceMappingURL=get-films-for-site.js.map